// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AvailabilityTimeWindowFieldsFragment = { __typename?: 'AvailabilityTimeWindow', start_time: number, end_time: number, total_slots: number, booked_slots: number, available_slots: number, is_available: boolean, is_default?: boolean | null };

export type AvailabilityFieldsFragment = { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, is_ai_suggestion?: boolean | null, single_use_ref_type?: Types.EntityType | null, created_at: number, updated_at: number, time_windows?: Array<{ __typename?: 'AvailabilityTimeWindow', start_time: number, end_time: number, total_slots: number, booked_slots: number, available_slots: number, is_available: boolean, is_default?: boolean | null }> | null };

export type GenericAvailabilityNoteFieldsFragment = { __typename?: 'GenericAvailabilityNote', id: string, date: number, content: string, created_at: number, updated_at: number };

export type ResourceWithAvailabilitySupportFieldsFragment = { __typename?: 'ResourceWithAvailabilitySupport', id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, supports_slots: boolean, supports_hourly_availability: boolean, notes?: Array<{ __typename?: 'GenericAvailabilityNote', id: string, date: number, content: string, created_at: number, updated_at: number }> | null };

export type CheckoutCalendarAvailabilityTimeWindowFragment = { __typename?: 'CheckoutCalendarAvailabilityTimeWindow', start_time: number, end_time: number };

export type AvailableDatesForEditBookingQueryVariables = Types.Exact<{
  data: Types.AvailableDatesForEditBookingInput;
}>;


export type AvailableDatesForEditBookingQuery = { __typename?: 'Query', availableDatesForEditBooking: Array<{ __typename?: 'CheckoutCalendarDateWithTimeWindows', date: number, time_windows: Array<{ __typename?: 'CheckoutCalendarAvailabilityTimeWindow', start_time: number, end_time: number }> }> };

export type AvailabilityQueryVariables = Types.Exact<{
  data: Types.GetGenericAvailabilityInput;
}>;


export type AvailabilityQuery = { __typename?: 'Query', availability: Array<{ __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, is_ai_suggestion?: boolean | null, single_use_ref_type?: Types.EntityType | null, created_at: number, updated_at: number, time_windows?: Array<{ __typename?: 'AvailabilityTimeWindow', start_time: number, end_time: number, total_slots: number, booked_slots: number, available_slots: number, is_available: boolean, is_default?: boolean | null }> | null }> };

export type AvailableDatesForCalendarEventResourcesQueryVariables = Types.Exact<{
  data: Types.AvailableDatesForCalendarEventResourcesInput;
}>;


export type AvailableDatesForCalendarEventResourcesQuery = { __typename?: 'Query', availableDatesForCalendarEventResources: Array<number> };

export type ListingAvailabilityForDashboardCheckoutQueryVariables = Types.Exact<{
  data: Types.DashboardCheckoutAvailabilityInput;
}>;


export type ListingAvailabilityForDashboardCheckoutQuery = { __typename?: 'Query', listingAvailabilityForDashboardCheckout: Array<number> };

export type DashboardCheckoutMaxAvailableSlotsQueryVariables = Types.Exact<{
  data: Types.CheckoutMaxSlotsInput;
}>;


export type DashboardCheckoutMaxAvailableSlotsQuery = { __typename?: 'Query', dashboardCheckoutMaxAvailableSlots: { __typename?: 'CheckoutMaxSlots', max_available_slots: number } };

export type ResourcesWithSupportForAvailabilityQueryVariables = Types.Exact<{
  resourceType: Types.ResourceType;
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type ResourcesWithSupportForAvailabilityQuery = { __typename?: 'Query', resourcesWithSupportForAvailability: Array<{ __typename?: 'ResourceWithAvailabilitySupport', id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, supports_slots: boolean, supports_hourly_availability: boolean, notes?: Array<{ __typename?: 'GenericAvailabilityNote', id: string, date: number, content: string, created_at: number, updated_at: number }> | null }> };

export type ResourceWithSupportForAvailabilityQueryVariables = Types.Exact<{
  resourceType: Types.ResourceType;
  outfitterId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type ResourceWithSupportForAvailabilityQuery = { __typename?: 'Query', resourceWithSupportForAvailability?: { __typename?: 'ResourceWithAvailabilitySupport', id: string, type: Types.ResourceType, name: string, is_single_use?: boolean | null, supports_slots: boolean, supports_hourly_availability: boolean, notes?: Array<{ __typename?: 'GenericAvailabilityNote', id: string, date: number, content: string, created_at: number, updated_at: number }> | null } | null };

export type UpdateAvailabilityMutationVariables = Types.Exact<{
  data: Types.AvailabilityUpdateInput;
}>;


export type UpdateAvailabilityMutation = { __typename?: 'Mutation', updateAvailability?: any | null };

export type AcceptAvailabilityAiSuggestionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AcceptAvailabilityAiSuggestionMutation = { __typename?: 'Mutation', acceptAvailabilityAiSuggestion: Array<{ __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, is_ai_suggestion?: boolean | null, single_use_ref_type?: Types.EntityType | null, created_at: number, updated_at: number, time_windows?: Array<{ __typename?: 'AvailabilityTimeWindow', start_time: number, end_time: number, total_slots: number, booked_slots: number, available_slots: number, is_available: boolean, is_default?: boolean | null }> | null }> };

export const AvailabilityTimeWindowFieldsFragmentDoc = gql`
    fragment AvailabilityTimeWindowFields on AvailabilityTimeWindow {
  start_time
  end_time
  total_slots
  booked_slots
  available_slots
  is_available
  is_default
}
    `;
export const AvailabilityFieldsFragmentDoc = gql`
    fragment AvailabilityFields on GenericAvailabilityEntry {
  id
  resource_type
  resource_id
  date
  is_available
  total_slots
  booked_slots
  available_slots
  is_ai_suggestion
  single_use_ref_type
  time_windows {
    ...AvailabilityTimeWindowFields
  }
  created_at
  updated_at
}
    ${AvailabilityTimeWindowFieldsFragmentDoc}`;
export const GenericAvailabilityNoteFieldsFragmentDoc = gql`
    fragment GenericAvailabilityNoteFields on GenericAvailabilityNote {
  id
  date
  content
  created_at
  updated_at
}
    `;
export const ResourceWithAvailabilitySupportFieldsFragmentDoc = gql`
    fragment ResourceWithAvailabilitySupportFields on ResourceWithAvailabilitySupport {
  id
  type
  name
  is_single_use
  supports_slots
  supports_hourly_availability
  notes {
    ...GenericAvailabilityNoteFields
  }
}
    ${GenericAvailabilityNoteFieldsFragmentDoc}`;
export const CheckoutCalendarAvailabilityTimeWindowFragmentDoc = gql`
    fragment CheckoutCalendarAvailabilityTimeWindow on CheckoutCalendarAvailabilityTimeWindow {
  start_time
  end_time
}
    `;
export const AvailableDatesForEditBookingDocument = gql`
    query availableDatesForEditBooking($data: AvailableDatesForEditBookingInput!) {
  availableDatesForEditBooking(data: $data) {
    date
    time_windows {
      ...CheckoutCalendarAvailabilityTimeWindow
    }
  }
}
    ${CheckoutCalendarAvailabilityTimeWindowFragmentDoc}`;

/**
 * __useAvailableDatesForEditBookingQuery__
 *
 * To run a query within a React component, call `useAvailableDatesForEditBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableDatesForEditBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableDatesForEditBookingQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAvailableDatesForEditBookingQuery(baseOptions: Apollo.QueryHookOptions<AvailableDatesForEditBookingQuery, AvailableDatesForEditBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableDatesForEditBookingQuery, AvailableDatesForEditBookingQueryVariables>(AvailableDatesForEditBookingDocument, options);
      }
export function useAvailableDatesForEditBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableDatesForEditBookingQuery, AvailableDatesForEditBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableDatesForEditBookingQuery, AvailableDatesForEditBookingQueryVariables>(AvailableDatesForEditBookingDocument, options);
        }
export type AvailableDatesForEditBookingQueryHookResult = ReturnType<typeof useAvailableDatesForEditBookingQuery>;
export type AvailableDatesForEditBookingLazyQueryHookResult = ReturnType<typeof useAvailableDatesForEditBookingLazyQuery>;
export type AvailableDatesForEditBookingQueryResult = Apollo.QueryResult<AvailableDatesForEditBookingQuery, AvailableDatesForEditBookingQueryVariables>;
export const AvailabilityDocument = gql`
    query availability($data: GetGenericAvailabilityInput!) {
  availability(data: $data) {
    ...AvailabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;

/**
 * __useAvailabilityQuery__
 *
 * To run a query within a React component, call `useAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityQuery, AvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, options);
      }
export function useAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityQuery, AvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, options);
        }
export type AvailabilityQueryHookResult = ReturnType<typeof useAvailabilityQuery>;
export type AvailabilityLazyQueryHookResult = ReturnType<typeof useAvailabilityLazyQuery>;
export type AvailabilityQueryResult = Apollo.QueryResult<AvailabilityQuery, AvailabilityQueryVariables>;
export const AvailableDatesForCalendarEventResourcesDocument = gql`
    query availableDatesForCalendarEventResources($data: AvailableDatesForCalendarEventResourcesInput!) {
  availableDatesForCalendarEventResources(data: $data)
}
    `;

/**
 * __useAvailableDatesForCalendarEventResourcesQuery__
 *
 * To run a query within a React component, call `useAvailableDatesForCalendarEventResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableDatesForCalendarEventResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableDatesForCalendarEventResourcesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAvailableDatesForCalendarEventResourcesQuery(baseOptions: Apollo.QueryHookOptions<AvailableDatesForCalendarEventResourcesQuery, AvailableDatesForCalendarEventResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableDatesForCalendarEventResourcesQuery, AvailableDatesForCalendarEventResourcesQueryVariables>(AvailableDatesForCalendarEventResourcesDocument, options);
      }
export function useAvailableDatesForCalendarEventResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableDatesForCalendarEventResourcesQuery, AvailableDatesForCalendarEventResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableDatesForCalendarEventResourcesQuery, AvailableDatesForCalendarEventResourcesQueryVariables>(AvailableDatesForCalendarEventResourcesDocument, options);
        }
export type AvailableDatesForCalendarEventResourcesQueryHookResult = ReturnType<typeof useAvailableDatesForCalendarEventResourcesQuery>;
export type AvailableDatesForCalendarEventResourcesLazyQueryHookResult = ReturnType<typeof useAvailableDatesForCalendarEventResourcesLazyQuery>;
export type AvailableDatesForCalendarEventResourcesQueryResult = Apollo.QueryResult<AvailableDatesForCalendarEventResourcesQuery, AvailableDatesForCalendarEventResourcesQueryVariables>;
export const ListingAvailabilityForDashboardCheckoutDocument = gql`
    query listingAvailabilityForDashboardCheckout($data: DashboardCheckoutAvailabilityInput!) {
  listingAvailabilityForDashboardCheckout(data: $data)
}
    `;

/**
 * __useListingAvailabilityForDashboardCheckoutQuery__
 *
 * To run a query within a React component, call `useListingAvailabilityForDashboardCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingAvailabilityForDashboardCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingAvailabilityForDashboardCheckoutQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useListingAvailabilityForDashboardCheckoutQuery(baseOptions: Apollo.QueryHookOptions<ListingAvailabilityForDashboardCheckoutQuery, ListingAvailabilityForDashboardCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingAvailabilityForDashboardCheckoutQuery, ListingAvailabilityForDashboardCheckoutQueryVariables>(ListingAvailabilityForDashboardCheckoutDocument, options);
      }
export function useListingAvailabilityForDashboardCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingAvailabilityForDashboardCheckoutQuery, ListingAvailabilityForDashboardCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingAvailabilityForDashboardCheckoutQuery, ListingAvailabilityForDashboardCheckoutQueryVariables>(ListingAvailabilityForDashboardCheckoutDocument, options);
        }
export type ListingAvailabilityForDashboardCheckoutQueryHookResult = ReturnType<typeof useListingAvailabilityForDashboardCheckoutQuery>;
export type ListingAvailabilityForDashboardCheckoutLazyQueryHookResult = ReturnType<typeof useListingAvailabilityForDashboardCheckoutLazyQuery>;
export type ListingAvailabilityForDashboardCheckoutQueryResult = Apollo.QueryResult<ListingAvailabilityForDashboardCheckoutQuery, ListingAvailabilityForDashboardCheckoutQueryVariables>;
export const DashboardCheckoutMaxAvailableSlotsDocument = gql`
    query dashboardCheckoutMaxAvailableSlots($data: CheckoutMaxSlotsInput!) {
  dashboardCheckoutMaxAvailableSlots(data: $data) {
    max_available_slots
  }
}
    `;

/**
 * __useDashboardCheckoutMaxAvailableSlotsQuery__
 *
 * To run a query within a React component, call `useDashboardCheckoutMaxAvailableSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCheckoutMaxAvailableSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCheckoutMaxAvailableSlotsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDashboardCheckoutMaxAvailableSlotsQuery(baseOptions: Apollo.QueryHookOptions<DashboardCheckoutMaxAvailableSlotsQuery, DashboardCheckoutMaxAvailableSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCheckoutMaxAvailableSlotsQuery, DashboardCheckoutMaxAvailableSlotsQueryVariables>(DashboardCheckoutMaxAvailableSlotsDocument, options);
      }
export function useDashboardCheckoutMaxAvailableSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCheckoutMaxAvailableSlotsQuery, DashboardCheckoutMaxAvailableSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCheckoutMaxAvailableSlotsQuery, DashboardCheckoutMaxAvailableSlotsQueryVariables>(DashboardCheckoutMaxAvailableSlotsDocument, options);
        }
export type DashboardCheckoutMaxAvailableSlotsQueryHookResult = ReturnType<typeof useDashboardCheckoutMaxAvailableSlotsQuery>;
export type DashboardCheckoutMaxAvailableSlotsLazyQueryHookResult = ReturnType<typeof useDashboardCheckoutMaxAvailableSlotsLazyQuery>;
export type DashboardCheckoutMaxAvailableSlotsQueryResult = Apollo.QueryResult<DashboardCheckoutMaxAvailableSlotsQuery, DashboardCheckoutMaxAvailableSlotsQueryVariables>;
export const ResourcesWithSupportForAvailabilityDocument = gql`
    query resourcesWithSupportForAvailability($resourceType: ResourceType!, $outfitterId: ID!) {
  resourcesWithSupportForAvailability(
    resourceType: $resourceType
    outfitterId: $outfitterId
  ) {
    ...ResourceWithAvailabilitySupportFields
  }
}
    ${ResourceWithAvailabilitySupportFieldsFragmentDoc}`;

/**
 * __useResourcesWithSupportForAvailabilityQuery__
 *
 * To run a query within a React component, call `useResourcesWithSupportForAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesWithSupportForAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesWithSupportForAvailabilityQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useResourcesWithSupportForAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<ResourcesWithSupportForAvailabilityQuery, ResourcesWithSupportForAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesWithSupportForAvailabilityQuery, ResourcesWithSupportForAvailabilityQueryVariables>(ResourcesWithSupportForAvailabilityDocument, options);
      }
export function useResourcesWithSupportForAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesWithSupportForAvailabilityQuery, ResourcesWithSupportForAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesWithSupportForAvailabilityQuery, ResourcesWithSupportForAvailabilityQueryVariables>(ResourcesWithSupportForAvailabilityDocument, options);
        }
export type ResourcesWithSupportForAvailabilityQueryHookResult = ReturnType<typeof useResourcesWithSupportForAvailabilityQuery>;
export type ResourcesWithSupportForAvailabilityLazyQueryHookResult = ReturnType<typeof useResourcesWithSupportForAvailabilityLazyQuery>;
export type ResourcesWithSupportForAvailabilityQueryResult = Apollo.QueryResult<ResourcesWithSupportForAvailabilityQuery, ResourcesWithSupportForAvailabilityQueryVariables>;
export const ResourceWithSupportForAvailabilityDocument = gql`
    query resourceWithSupportForAvailability($resourceType: ResourceType!, $outfitterId: ID!, $id: ID!) {
  resourceWithSupportForAvailability(
    resourceType: $resourceType
    id: $id
    outfitterId: $outfitterId
  ) {
    ...ResourceWithAvailabilitySupportFields
  }
}
    ${ResourceWithAvailabilitySupportFieldsFragmentDoc}`;

/**
 * __useResourceWithSupportForAvailabilityQuery__
 *
 * To run a query within a React component, call `useResourceWithSupportForAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceWithSupportForAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceWithSupportForAvailabilityQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      outfitterId: // value for 'outfitterId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceWithSupportForAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<ResourceWithSupportForAvailabilityQuery, ResourceWithSupportForAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceWithSupportForAvailabilityQuery, ResourceWithSupportForAvailabilityQueryVariables>(ResourceWithSupportForAvailabilityDocument, options);
      }
export function useResourceWithSupportForAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceWithSupportForAvailabilityQuery, ResourceWithSupportForAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceWithSupportForAvailabilityQuery, ResourceWithSupportForAvailabilityQueryVariables>(ResourceWithSupportForAvailabilityDocument, options);
        }
export type ResourceWithSupportForAvailabilityQueryHookResult = ReturnType<typeof useResourceWithSupportForAvailabilityQuery>;
export type ResourceWithSupportForAvailabilityLazyQueryHookResult = ReturnType<typeof useResourceWithSupportForAvailabilityLazyQuery>;
export type ResourceWithSupportForAvailabilityQueryResult = Apollo.QueryResult<ResourceWithSupportForAvailabilityQuery, ResourceWithSupportForAvailabilityQueryVariables>;
export const UpdateAvailabilityDocument = gql`
    mutation updateAvailability($data: AvailabilityUpdateInput!) {
  updateAvailability(data: $data)
}
    `;
export type UpdateAvailabilityMutationFn = Apollo.MutationFunction<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;

/**
 * __useUpdateAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityMutation, { data, loading, error }] = useUpdateAvailabilityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>(UpdateAvailabilityDocument, options);
      }
export type UpdateAvailabilityMutationHookResult = ReturnType<typeof useUpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationResult = Apollo.MutationResult<UpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;
export const AcceptAvailabilityAiSuggestionDocument = gql`
    mutation acceptAvailabilityAiSuggestion($id: ID!) {
  acceptAvailabilityAiSuggestion(id: $id) {
    ...AvailabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;
export type AcceptAvailabilityAiSuggestionMutationFn = Apollo.MutationFunction<AcceptAvailabilityAiSuggestionMutation, AcceptAvailabilityAiSuggestionMutationVariables>;

/**
 * __useAcceptAvailabilityAiSuggestionMutation__
 *
 * To run a mutation, you first call `useAcceptAvailabilityAiSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAvailabilityAiSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAvailabilityAiSuggestionMutation, { data, loading, error }] = useAcceptAvailabilityAiSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptAvailabilityAiSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAvailabilityAiSuggestionMutation, AcceptAvailabilityAiSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAvailabilityAiSuggestionMutation, AcceptAvailabilityAiSuggestionMutationVariables>(AcceptAvailabilityAiSuggestionDocument, options);
      }
export type AcceptAvailabilityAiSuggestionMutationHookResult = ReturnType<typeof useAcceptAvailabilityAiSuggestionMutation>;
export type AcceptAvailabilityAiSuggestionMutationResult = Apollo.MutationResult<AcceptAvailabilityAiSuggestionMutation>;
export type AcceptAvailabilityAiSuggestionMutationOptions = Apollo.BaseMutationOptions<AcceptAvailabilityAiSuggestionMutation, AcceptAvailabilityAiSuggestionMutationVariables>;